/**
 * 受注変更履歴
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/collections`

const driver_order_accept_collection_revision_history = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @return {Promise<unknown>}
     */
    index ({ commit }, { order_id, params }) {
      const api_path = `${API_PATH}/${order_id}/revision_histories`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default driver_order_accept_collection_revision_history
